import { styled } from '@glitz/react';
import * as style from '../Style';

export default styled.h2({
  fontSize: style.beta,
  fontWeight: 'normal',
  lineHeight: 'normal',
  letterSpacing: '3px',
});
